import './instrument'
import './index.css'

import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import Forbidden from './components/error/forbidden'

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div className="flex h-screen items-center justify-center">
          <Forbidden error="Ops... Reload the page and try again" />
        </div>
      }
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
